/** YouTube upload settings (Social Automator composer). */
export const enYouTube = {
  'youtube.settingsTitle': 'YouTube Settings',
  'youtube.visibility': 'Visibility',
  'youtube.visibilityPrivate': 'Private — only you can watch it',
  'youtube.visibilityUnlisted': 'Unlisted — anyone with the link can watch',
  'youtube.visibilityPublic': 'Public — listed on your channel and searchable',
  'youtube.visibilityHint':
    'You can change this on YouTube afterwards, but a video that goes public cannot be un-seen — BuzzBit uploads privately unless you choose otherwise.',
  'youtube.needsVideo': 'YouTube needs a video. Add one above, or unselect YouTube.',
} as const;
